export default __webpack_public_path__ + "static/media/Media.3b67822c.svg";